import { Outlet, RouteObject } from 'react-router-dom'
import DynamicQueues from '../pages/queue-configuration/DynamicQueues'

const workBasketRoutes: RouteObject = {
  path: '',
  element: <Outlet />,
  children: [
    {
      path: '/my-cases/:entityid/:layoutid/:id',
      element: (
        <DynamicQueues uniqueKey={''} isCaseWorkBasket={true} key={'my-case'} />
      ),
      handle: {
        crumb: () => 'My Cases',
      },
    },

    {
      path: '/my-tasks/:entityid/:layoutid/:id',
      element: (
        <DynamicQueues uniqueKey={''} isTaskWorkBasket={true} key={'my-task'} />
      ),
      handle: {
        crumb: () => 'My Tasks',
      },
    },
  ],
}
export default workBasketRoutes
